import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Logo = () => {
  const navigate = useNavigate();

  const redirectToOrderProcessing = () => {
    navigate("/order-processing");
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      console.log(window.innerWidth);
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div onClick={redirectToOrderProcessing} style={{ cursor: "pointer" }}>
      <img height={48} src="/logo.png" />
    </div>
  );
};

export default Logo;
